"use strict";

var _classCallCheck = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var EditableLabel = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(EditableLabel, _react$default$Compon);

  var _super = _createSuper(EditableLabel);

  function EditableLabel(_ref2) {
    var _this;

    var _value = _ref2.value;

    _classCallCheck(this, EditableLabel);

    _this = _super.call(this);
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "getText", function (el) {
      return el.innerText;
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onTextChange", function (ev) {
      var value = _this.getText(ev.target);

      _this.setState({
        value: value
      });
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onBlur", function () {
      _this.props.onChange(_this.state.value);
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onPaste", function (ev) {
      ev.preventDefault();
      var value = ev.clipboardData.getData('text');
      document.execCommand('insertText', false, value);
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "getClassName", function () {
      var placeholder = _this.state.value === '' ? 'comPlainTextContentEditable--has-placeholder' : '';
      return "comPlainTextContentEditable ".concat(placeholder);
    });
    (0, _defineProperty2.default)(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode === 13) {
        _this.props.onChange(_this.state.value);

        _this.refDiv.blur();

        e.preventDefault();
      }

      if (e.keyCode === 27) {
        _this.refDiv.value = _this.props.value;

        _this.setState({
          value: _this.props.value
        }); // this.refDiv.blur()


        e.preventDefault();
        e.stopPropagation();
      }
    });
    _this.state = {
      value: _value
    };
    return _this;
  }

  _createClass(EditableLabel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.refDiv.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var placeholder = this.props.value.length > 0 ? false : this.props.placeholder;
      return _react.default.createElement("div", {
        ref: function ref(_ref) {
          return _this2.refDiv = _ref;
        },
        contentEditable: "true",
        className: this.getClassName(),
        onPaste: this.onPaste,
        onBlur: this.onBlur,
        onInput: this.onTextChange,
        onKeyDown: this.onKeyDown,
        placeholder: placeholder
      });
    }
  }]);

  return EditableLabel;
}(_react.default.Component);

EditableLabel.propTypes = {
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  inline: _propTypes.default.bool,
  value: _propTypes.default.string
};
EditableLabel.defaultProps = {
  onChange: function onChange() {},
  placeholder: '',
  autoFocus: false,
  inline: false,
  value: ''
};
var _default = EditableLabel;
exports.default = _default;